import api from './apiClient';

export const seatMapApi = {
  async getVenueLayout(venueId, eventId) {
    try {
      return await api.get(`/seat-map/venue/${venueId}/event/${eventId}`);
    } catch (error) {
      console.error('Error fetching venue layout:', error);
      throw error;
    }
  },

  async getSectionSeats(sectionId, eventId) {
    try {
      return await api.get(`/seat-map/section/${sectionId}/event/${eventId}/seats`);
    } catch (error) {
      console.error('Error fetching section seats:', error);
      throw error;
    }
  },

  async findBestAvailable(eventId, ticketTypeId, quantity) {
    try {
      return await api.get('/seat-map/best-available', {
        params: { eventId, ticketTypeId, quantity },
      });
    } catch (error) {
      console.error('Error finding best available seats:', error);
      throw error;
    }
  },

  async getPricingOptions(eventId) {
    try {
      return await api.get(`/seat-map/pricing/${eventId}`);
    } catch (error) {
      console.error('Error fetching pricing options:', error);
      throw error;
    }
  },

  async applyOfferCode(code, eventId, seatIds) {
    try {
      return await api.post('/seat-map/apply-offer', { code, eventId, seatIds });
    } catch (error) {
      console.error('Error applying offer code:', error);
      throw error;
    }
  },

  async checkSeatAvailability(seatIds, eventId) {
    try {
      return await api.post('/seat-map/check-availability', { seatIds, eventId });
    } catch (error) {
      console.error('Error checking seat availability:', error);
      throw error;
    }
  },

  async holdSeats(seatIds, eventId) {
    try {
      return await api.post('/seat-map/hold-seats', { seatIds, eventId });
    } catch (error) {
      console.error('Error holding seats:', error);
      throw error;
    }
  },

  async getVenueStats(venueId) {
    try {
      return await api.get(`/seat-map/venue/${venueId}/stats`);
    } catch (error) {
      console.error('Error fetching venue stats:', error);
      throw error;
    }
  },

  // --- Chart Management (Admin/Planner) ---

  async listCharts() {
    try {
      return await api.get('/v1/seat-maps');
    } catch (error) {
      console.error('Error listing seat maps:', error);
      throw error;
    }
  },

  async getChart(key) {
    try {
      return await api.get(`/v1/seat-maps/${key}`);
    } catch (error) {
      console.error('Error getting seat map:', error);
      throw error;
    }
  },

  async duplicateChart(key, newName) {
    try {
      return await api.post(`/v1/seat-maps/${key}/duplicate`, null, {
        params: { newName }
      });
    } catch (error) {
      console.error('Error duplicating seat map:', error);
      throw error;
    }
  },

  async updateChartCategories(key, categories) {
    try {
      return await api.post(`/v1/seat-maps/${key}/categories`, categories);
    } catch (error) {
      console.error('Error updating chart categories:', error);
      throw error;
    }
  },

  async createChart(name) {
    try {
      return await api.post('/v1/seat-maps', null, {
        params: { name }
      });
    } catch (error) {
      console.error('Error creating seat map:', error);
      throw error;
    }
  },

  async deleteChart(key) {
    try {
      return await api.delete(`/v1/seat-maps/${key}`);
    } catch (error) {
      console.error('Error deleting seat map:', error);
      throw error;
    }
  }
};

export default seatMapApi;

